// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: dom_flight.proto

/* eslint-disable */
import { SearchSource, searchSourceFromJSON, searchSourceToJSON } from "./common_enum";
import {
  BackButtonSource,
  backButtonSourceFromJSON,
  backButtonSourceToJSON,
  CabinType,
  cabinTypeFromJSON,
  cabinTypeToJSON,
  DepartureTime,
  departureTimeFromJSON,
  departureTimeToJSON,
  FieldError,
  SortingOption,
  sortingOptionFromJSON,
  sortingOptionToJSON,
  TripType,
  tripTypeFromJSON,
  tripTypeToJSON,
} from "./flights_enum";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "usertracking.v3";

export interface DomFlight {
  departure_date: Date | undefined;
  arrival_date: Date | undefined;
  return_departure_date: Date | undefined;
  return_arrival_date: Date | undefined;
  origin_city: string;
  destination_city: string;
  cabin_type: CabinType;
  trip_type: TripType;
  number_of_passengers: number;
  route: string;
  search_source: SearchSource;
  search_window: number;
  user_segment_name: string[];
  number_of_prev_orders: number;
  number_of_results: number;
  position_rank: number;
  is_best_flight: boolean;
  has_filters_on: boolean;
  filters: string[];
  return_flight_capacity: number;
  departure_flight_capacity: number;
  departure_airline: string;
  return_airline: string;
  sorting_option: SortingOption;
  stock: string;
  system_name: string;
  has_free_cancellation_selected: boolean;
  has_voucher_code_enabled: boolean;
  checkout_source: string;
  payment_gateway: string;
  is_snappay_eligible: boolean;
  eligible_payment_gateways: string[];
  gateway: string;
  is_price_table_best_price: boolean;
  filter_field: string;
  leg: string;
  back_button_source: BackButtonSource;
  type_errors: FieldError[];
  total_price: number;
  wallet_balance: number;
  required_charging: boolean;
  departure_time: DepartureTime[];
  origin_is_city: boolean;
  destination_is_city: boolean;
  origin_airport: string;
  destination_airport: string;
  search_calendar_type: string;
  trip_purpose: string;
  is_price_calendar_best_price: boolean;
  adult_count: number;
  child_count: number;
  infant_count: number;
  number_of_more_than_max_price: number;
  search_started: number;
  results_rendered: number;
  search_response_received: number;
  backend_latency: number;
  frontend_rendering_time: number;
  total_wait_time: number;
  basket_price: number;
  ycard_balance: number;
  penny_balance: number;
  origin_rank: number;
  destination_rank: number;
}

function createBaseDomFlight(): DomFlight {
  return {
    departure_date: undefined,
    arrival_date: undefined,
    return_departure_date: undefined,
    return_arrival_date: undefined,
    origin_city: "",
    destination_city: "",
    cabin_type: CabinType.economy,
    trip_type: TripType.one_way,
    number_of_passengers: 0,
    route: "",
    search_source: SearchSource.search_box,
    search_window: 0,
    user_segment_name: [],
    number_of_prev_orders: 0,
    number_of_results: 0,
    position_rank: 0,
    is_best_flight: false,
    has_filters_on: false,
    filters: [],
    return_flight_capacity: 0,
    departure_flight_capacity: 0,
    departure_airline: "",
    return_airline: "",
    sorting_option: SortingOption.best,
    stock: "",
    system_name: "",
    has_free_cancellation_selected: false,
    has_voucher_code_enabled: false,
    checkout_source: "",
    payment_gateway: "",
    is_snappay_eligible: false,
    eligible_payment_gateways: [],
    gateway: "",
    is_price_table_best_price: false,
    filter_field: "",
    leg: "",
    back_button_source: BackButtonSource.header,
    type_errors: [],
    total_price: 0,
    wallet_balance: 0,
    required_charging: false,
    departure_time: [],
    origin_is_city: false,
    destination_is_city: false,
    origin_airport: "",
    destination_airport: "",
    search_calendar_type: "",
    trip_purpose: "",
    is_price_calendar_best_price: false,
    adult_count: 0,
    child_count: 0,
    infant_count: 0,
    number_of_more_than_max_price: 0,
    search_started: 0,
    results_rendered: 0,
    search_response_received: 0,
    backend_latency: 0,
    frontend_rendering_time: 0,
    total_wait_time: 0,
    basket_price: 0,
    ycard_balance: 0,
    penny_balance: 0,
    origin_rank: 0,
    destination_rank: 0,
  };
}

export const DomFlight: MessageFns<DomFlight> = {
  fromJSON(object: any): DomFlight {
    return {
      departure_date: isSet(object.departure_date) ? fromJsonTimestamp(object.departure_date) : undefined,
      arrival_date: isSet(object.arrival_date) ? fromJsonTimestamp(object.arrival_date) : undefined,
      return_departure_date: isSet(object.return_departure_date)
        ? fromJsonTimestamp(object.return_departure_date)
        : undefined,
      return_arrival_date: isSet(object.return_arrival_date)
        ? fromJsonTimestamp(object.return_arrival_date)
        : undefined,
      origin_city: isSet(object.origin_city) ? globalThis.String(object.origin_city) : "",
      destination_city: isSet(object.destination_city) ? globalThis.String(object.destination_city) : "",
      cabin_type: isSet(object.cabin_type) ? cabinTypeFromJSON(object.cabin_type) : CabinType.economy,
      trip_type: isSet(object.trip_type) ? tripTypeFromJSON(object.trip_type) : TripType.one_way,
      number_of_passengers: isSet(object.number_of_passengers) ? globalThis.Number(object.number_of_passengers) : 0,
      route: isSet(object.route) ? globalThis.String(object.route) : "",
      search_source: isSet(object.search_source) ? searchSourceFromJSON(object.search_source) : SearchSource.search_box,
      search_window: isSet(object.search_window) ? globalThis.Number(object.search_window) : 0,
      user_segment_name: globalThis.Array.isArray(object?.user_segment_name)
        ? object.user_segment_name.map((e: any) => globalThis.String(e))
        : [],
      number_of_prev_orders: isSet(object.number_of_prev_orders) ? globalThis.Number(object.number_of_prev_orders) : 0,
      number_of_results: isSet(object.number_of_results) ? globalThis.Number(object.number_of_results) : 0,
      position_rank: isSet(object.position_rank) ? globalThis.Number(object.position_rank) : 0,
      is_best_flight: isSet(object.is_best_flight) ? globalThis.Boolean(object.is_best_flight) : false,
      has_filters_on: isSet(object.has_filters_on) ? globalThis.Boolean(object.has_filters_on) : false,
      filters: globalThis.Array.isArray(object?.filters) ? object.filters.map((e: any) => globalThis.String(e)) : [],
      return_flight_capacity: isSet(object.return_flight_capacity)
        ? globalThis.Number(object.return_flight_capacity)
        : 0,
      departure_flight_capacity: isSet(object.departure_flight_capacity)
        ? globalThis.Number(object.departure_flight_capacity)
        : 0,
      departure_airline: isSet(object.departure_airline) ? globalThis.String(object.departure_airline) : "",
      return_airline: isSet(object.return_airline) ? globalThis.String(object.return_airline) : "",
      sorting_option: isSet(object.sorting_option) ? sortingOptionFromJSON(object.sorting_option) : SortingOption.best,
      stock: isSet(object.stock) ? globalThis.String(object.stock) : "",
      system_name: isSet(object.system_name) ? globalThis.String(object.system_name) : "",
      has_free_cancellation_selected: isSet(object.has_free_cancellation_selected)
        ? globalThis.Boolean(object.has_free_cancellation_selected)
        : false,
      has_voucher_code_enabled: isSet(object.has_voucher_code_enabled)
        ? globalThis.Boolean(object.has_voucher_code_enabled)
        : false,
      checkout_source: isSet(object.checkout_source) ? globalThis.String(object.checkout_source) : "",
      payment_gateway: isSet(object.payment_gateway) ? globalThis.String(object.payment_gateway) : "",
      is_snappay_eligible: isSet(object.is_snappay_eligible) ? globalThis.Boolean(object.is_snappay_eligible) : false,
      eligible_payment_gateways: globalThis.Array.isArray(object?.eligible_payment_gateways)
        ? object.eligible_payment_gateways.map((e: any) => globalThis.String(e))
        : [],
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      is_price_table_best_price: isSet(object.is_price_table_best_price)
        ? globalThis.Boolean(object.is_price_table_best_price)
        : false,
      filter_field: isSet(object.filter_field) ? globalThis.String(object.filter_field) : "",
      leg: isSet(object.leg) ? globalThis.String(object.leg) : "",
      back_button_source: isSet(object.back_button_source)
        ? backButtonSourceFromJSON(object.back_button_source)
        : BackButtonSource.header,
      type_errors: globalThis.Array.isArray(object?.type_errors)
        ? object.type_errors.map((e: any) => FieldError.fromJSON(e))
        : [],
      total_price: isSet(object.total_price) ? globalThis.Number(object.total_price) : 0,
      wallet_balance: isSet(object.wallet_balance) ? globalThis.Number(object.wallet_balance) : 0,
      required_charging: isSet(object.required_charging) ? globalThis.Boolean(object.required_charging) : false,
      departure_time: globalThis.Array.isArray(object?.departure_time)
        ? object.departure_time.map((e: any) => departureTimeFromJSON(e))
        : [],
      origin_is_city: isSet(object.origin_is_city) ? globalThis.Boolean(object.origin_is_city) : false,
      destination_is_city: isSet(object.destination_is_city) ? globalThis.Boolean(object.destination_is_city) : false,
      origin_airport: isSet(object.origin_airport) ? globalThis.String(object.origin_airport) : "",
      destination_airport: isSet(object.destination_airport) ? globalThis.String(object.destination_airport) : "",
      search_calendar_type: isSet(object.search_calendar_type) ? globalThis.String(object.search_calendar_type) : "",
      trip_purpose: isSet(object.trip_purpose) ? globalThis.String(object.trip_purpose) : "",
      is_price_calendar_best_price: isSet(object.is_price_calendar_best_price)
        ? globalThis.Boolean(object.is_price_calendar_best_price)
        : false,
      adult_count: isSet(object.adult_count) ? globalThis.Number(object.adult_count) : 0,
      child_count: isSet(object.child_count) ? globalThis.Number(object.child_count) : 0,
      infant_count: isSet(object.infant_count) ? globalThis.Number(object.infant_count) : 0,
      number_of_more_than_max_price: isSet(object.number_of_more_than_max_price)
        ? globalThis.Number(object.number_of_more_than_max_price)
        : 0,
      search_started: isSet(object.search_started) ? globalThis.Number(object.search_started) : 0,
      results_rendered: isSet(object.results_rendered) ? globalThis.Number(object.results_rendered) : 0,
      search_response_received: isSet(object.search_response_received)
        ? globalThis.Number(object.search_response_received)
        : 0,
      backend_latency: isSet(object.backend_latency) ? globalThis.Number(object.backend_latency) : 0,
      frontend_rendering_time: isSet(object.frontend_rendering_time)
        ? globalThis.Number(object.frontend_rendering_time)
        : 0,
      total_wait_time: isSet(object.total_wait_time) ? globalThis.Number(object.total_wait_time) : 0,
      basket_price: isSet(object.basket_price) ? globalThis.Number(object.basket_price) : 0,
      ycard_balance: isSet(object.ycard_balance) ? globalThis.Number(object.ycard_balance) : 0,
      penny_balance: isSet(object.penny_balance) ? globalThis.Number(object.penny_balance) : 0,
      origin_rank: isSet(object.origin_rank) ? globalThis.Number(object.origin_rank) : 0,
      destination_rank: isSet(object.destination_rank) ? globalThis.Number(object.destination_rank) : 0,
    };
  },

  toJSON(message: DomFlight): unknown {
    const obj: any = {};
    if (message.departure_date !== undefined) {
      obj.departure_date = message.departure_date.toISOString();
    }
    if (message.arrival_date !== undefined) {
      obj.arrival_date = message.arrival_date.toISOString();
    }
    if (message.return_departure_date !== undefined) {
      obj.return_departure_date = message.return_departure_date.toISOString();
    }
    if (message.return_arrival_date !== undefined) {
      obj.return_arrival_date = message.return_arrival_date.toISOString();
    }
    if (message.origin_city !== "") {
      obj.origin_city = message.origin_city;
    }
    if (message.destination_city !== "") {
      obj.destination_city = message.destination_city;
    }
    if (message.cabin_type !== CabinType.economy) {
      obj.cabin_type = cabinTypeToJSON(message.cabin_type);
    }
    if (message.trip_type !== TripType.one_way) {
      obj.trip_type = tripTypeToJSON(message.trip_type);
    }
    if (message.number_of_passengers !== 0) {
      obj.number_of_passengers = Math.round(message.number_of_passengers);
    }
    if (message.route !== "") {
      obj.route = message.route;
    }
    if (message.search_source !== SearchSource.search_box) {
      obj.search_source = searchSourceToJSON(message.search_source);
    }
    if (message.search_window !== 0) {
      obj.search_window = Math.round(message.search_window);
    }
    if (message.user_segment_name?.length) {
      obj.user_segment_name = message.user_segment_name;
    }
    if (message.number_of_prev_orders !== 0) {
      obj.number_of_prev_orders = Math.round(message.number_of_prev_orders);
    }
    if (message.number_of_results !== 0) {
      obj.number_of_results = Math.round(message.number_of_results);
    }
    if (message.position_rank !== 0) {
      obj.position_rank = Math.round(message.position_rank);
    }
    if (message.is_best_flight !== false) {
      obj.is_best_flight = message.is_best_flight;
    }
    if (message.has_filters_on !== false) {
      obj.has_filters_on = message.has_filters_on;
    }
    if (message.filters?.length) {
      obj.filters = message.filters;
    }
    if (message.return_flight_capacity !== 0) {
      obj.return_flight_capacity = message.return_flight_capacity;
    }
    if (message.departure_flight_capacity !== 0) {
      obj.departure_flight_capacity = message.departure_flight_capacity;
    }
    if (message.departure_airline !== "") {
      obj.departure_airline = message.departure_airline;
    }
    if (message.return_airline !== "") {
      obj.return_airline = message.return_airline;
    }
    if (message.sorting_option !== SortingOption.best) {
      obj.sorting_option = sortingOptionToJSON(message.sorting_option);
    }
    if (message.stock !== "") {
      obj.stock = message.stock;
    }
    if (message.system_name !== "") {
      obj.system_name = message.system_name;
    }
    if (message.has_free_cancellation_selected !== false) {
      obj.has_free_cancellation_selected = message.has_free_cancellation_selected;
    }
    if (message.has_voucher_code_enabled !== false) {
      obj.has_voucher_code_enabled = message.has_voucher_code_enabled;
    }
    if (message.checkout_source !== "") {
      obj.checkout_source = message.checkout_source;
    }
    if (message.payment_gateway !== "") {
      obj.payment_gateway = message.payment_gateway;
    }
    if (message.is_snappay_eligible !== false) {
      obj.is_snappay_eligible = message.is_snappay_eligible;
    }
    if (message.eligible_payment_gateways?.length) {
      obj.eligible_payment_gateways = message.eligible_payment_gateways;
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.is_price_table_best_price !== false) {
      obj.is_price_table_best_price = message.is_price_table_best_price;
    }
    if (message.filter_field !== "") {
      obj.filter_field = message.filter_field;
    }
    if (message.leg !== "") {
      obj.leg = message.leg;
    }
    if (message.back_button_source !== BackButtonSource.header) {
      obj.back_button_source = backButtonSourceToJSON(message.back_button_source);
    }
    if (message.type_errors?.length) {
      obj.type_errors = message.type_errors.map((e) => FieldError.toJSON(e));
    }
    if (message.total_price !== 0) {
      obj.total_price = Math.round(message.total_price);
    }
    if (message.wallet_balance !== 0) {
      obj.wallet_balance = Math.round(message.wallet_balance);
    }
    if (message.required_charging !== false) {
      obj.required_charging = message.required_charging;
    }
    if (message.departure_time?.length) {
      obj.departure_time = message.departure_time.map((e) => departureTimeToJSON(e));
    }
    if (message.origin_is_city !== false) {
      obj.origin_is_city = message.origin_is_city;
    }
    if (message.destination_is_city !== false) {
      obj.destination_is_city = message.destination_is_city;
    }
    if (message.origin_airport !== "") {
      obj.origin_airport = message.origin_airport;
    }
    if (message.destination_airport !== "") {
      obj.destination_airport = message.destination_airport;
    }
    if (message.search_calendar_type !== "") {
      obj.search_calendar_type = message.search_calendar_type;
    }
    if (message.trip_purpose !== "") {
      obj.trip_purpose = message.trip_purpose;
    }
    if (message.is_price_calendar_best_price !== false) {
      obj.is_price_calendar_best_price = message.is_price_calendar_best_price;
    }
    if (message.adult_count !== 0) {
      obj.adult_count = Math.round(message.adult_count);
    }
    if (message.child_count !== 0) {
      obj.child_count = Math.round(message.child_count);
    }
    if (message.infant_count !== 0) {
      obj.infant_count = Math.round(message.infant_count);
    }
    if (message.number_of_more_than_max_price !== 0) {
      obj.number_of_more_than_max_price = Math.round(message.number_of_more_than_max_price);
    }
    if (message.search_started !== 0) {
      obj.search_started = Math.round(message.search_started);
    }
    if (message.results_rendered !== 0) {
      obj.results_rendered = Math.round(message.results_rendered);
    }
    if (message.search_response_received !== 0) {
      obj.search_response_received = Math.round(message.search_response_received);
    }
    if (message.backend_latency !== 0) {
      obj.backend_latency = Math.round(message.backend_latency);
    }
    if (message.frontend_rendering_time !== 0) {
      obj.frontend_rendering_time = Math.round(message.frontend_rendering_time);
    }
    if (message.total_wait_time !== 0) {
      obj.total_wait_time = Math.round(message.total_wait_time);
    }
    if (message.basket_price !== 0) {
      obj.basket_price = Math.round(message.basket_price);
    }
    if (message.ycard_balance !== 0) {
      obj.ycard_balance = Math.round(message.ycard_balance);
    }
    if (message.penny_balance !== 0) {
      obj.penny_balance = Math.round(message.penny_balance);
    }
    if (message.origin_rank !== 0) {
      obj.origin_rank = Math.round(message.origin_rank);
    }
    if (message.destination_rank !== 0) {
      obj.destination_rank = Math.round(message.destination_rank);
    }
    return obj;
  },

  create(base?: DeepPartial<DomFlight>): DomFlight {
    return DomFlight.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DomFlight>): DomFlight {
    const message = createBaseDomFlight();
    message.departure_date = object.departure_date ?? undefined;
    message.arrival_date = object.arrival_date ?? undefined;
    message.return_departure_date = object.return_departure_date ?? undefined;
    message.return_arrival_date = object.return_arrival_date ?? undefined;
    message.origin_city = object.origin_city ?? "";
    message.destination_city = object.destination_city ?? "";
    message.cabin_type = object.cabin_type ?? CabinType.economy;
    message.trip_type = object.trip_type ?? TripType.one_way;
    message.number_of_passengers = object.number_of_passengers ?? 0;
    message.route = object.route ?? "";
    message.search_source = object.search_source ?? SearchSource.search_box;
    message.search_window = object.search_window ?? 0;
    message.user_segment_name = object.user_segment_name?.map((e) => e) || [];
    message.number_of_prev_orders = object.number_of_prev_orders ?? 0;
    message.number_of_results = object.number_of_results ?? 0;
    message.position_rank = object.position_rank ?? 0;
    message.is_best_flight = object.is_best_flight ?? false;
    message.has_filters_on = object.has_filters_on ?? false;
    message.filters = object.filters?.map((e) => e) || [];
    message.return_flight_capacity = object.return_flight_capacity ?? 0;
    message.departure_flight_capacity = object.departure_flight_capacity ?? 0;
    message.departure_airline = object.departure_airline ?? "";
    message.return_airline = object.return_airline ?? "";
    message.sorting_option = object.sorting_option ?? SortingOption.best;
    message.stock = object.stock ?? "";
    message.system_name = object.system_name ?? "";
    message.has_free_cancellation_selected = object.has_free_cancellation_selected ?? false;
    message.has_voucher_code_enabled = object.has_voucher_code_enabled ?? false;
    message.checkout_source = object.checkout_source ?? "";
    message.payment_gateway = object.payment_gateway ?? "";
    message.is_snappay_eligible = object.is_snappay_eligible ?? false;
    message.eligible_payment_gateways = object.eligible_payment_gateways?.map((e) => e) || [];
    message.gateway = object.gateway ?? "";
    message.is_price_table_best_price = object.is_price_table_best_price ?? false;
    message.filter_field = object.filter_field ?? "";
    message.leg = object.leg ?? "";
    message.back_button_source = object.back_button_source ?? BackButtonSource.header;
    message.type_errors = object.type_errors?.map((e) => FieldError.fromPartial(e)) || [];
    message.total_price = object.total_price ?? 0;
    message.wallet_balance = object.wallet_balance ?? 0;
    message.required_charging = object.required_charging ?? false;
    message.departure_time = object.departure_time?.map((e) => e) || [];
    message.origin_is_city = object.origin_is_city ?? false;
    message.destination_is_city = object.destination_is_city ?? false;
    message.origin_airport = object.origin_airport ?? "";
    message.destination_airport = object.destination_airport ?? "";
    message.search_calendar_type = object.search_calendar_type ?? "";
    message.trip_purpose = object.trip_purpose ?? "";
    message.is_price_calendar_best_price = object.is_price_calendar_best_price ?? false;
    message.adult_count = object.adult_count ?? 0;
    message.child_count = object.child_count ?? 0;
    message.infant_count = object.infant_count ?? 0;
    message.number_of_more_than_max_price = object.number_of_more_than_max_price ?? 0;
    message.search_started = object.search_started ?? 0;
    message.results_rendered = object.results_rendered ?? 0;
    message.search_response_received = object.search_response_received ?? 0;
    message.backend_latency = object.backend_latency ?? 0;
    message.frontend_rendering_time = object.frontend_rendering_time ?? 0;
    message.total_wait_time = object.total_wait_time ?? 0;
    message.basket_price = object.basket_price ?? 0;
    message.ycard_balance = object.ycard_balance ?? 0;
    message.penny_balance = object.penny_balance ?? 0;
    message.origin_rank = object.origin_rank ?? 0;
    message.destination_rank = object.destination_rank ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
